import { ref, reactive, toRefs } from 'vue';
import { defineStore, acceptHMRUpdate } from 'pinia';

const TOGGLES = {
  isNavOpen: false,
  isViewerActive: false,
  hasMaterialSelectionSidebar: false,
  forceForgeViewer: false,
  isProjectDetailsHidden: false,
};

export const useOrderUI = defineStore('orderUI', () => {
  const pageTitle = ref('');
  const toggles = reactive({ ...TOGGLES });
  const lastSavedAt = ref<Date | string>('');

  return {
    pageTitle,
    lastSavedAt,
    ...toRefs(toggles),

    toggle(key: keyof typeof TOGGLES, value?: boolean) {
      toggles[key] = value ?? !toggles[key];
    },
    reset() {
      pageTitle.value = '';
      lastSavedAt.value = '';
      for (const key in toggles) {
        toggles[key as keyof typeof TOGGLES] = false;
      }
    },
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useOrderUI, import.meta.hot));
}
